import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { fetchViewsPerPeriod } from "../../services/postService";
// import DashboardStatusGrid from "./DashboardStatusGrid";

function PostStatistics() {
  const [viewsOverTime, setViewsOverTime] = useState([]);
  const [viewGrouping, setViewGrouping] = useState("day");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchStats = async (customParams = {}) => {
    try {
      const response = await fetchViewsPerPeriod(customParams);
      setViewsOverTime(response.data || []);
      setViewGrouping(response.period || "day");
    } catch (error) {
      console.error("Failed to fetch view statistics:", error);
    }
  };

  useEffect(() => {
    fetchStats({});
  }, []);

  const handleFilter = () => {
    fetchStats({
      startDate: startDate || undefined,
      endDate: endDate || undefined,
    });
  };

  return (
    <div className="py-10 space-y-10">
      {/* Filters */}
      <div className="flex flex-wrap gap-4 items-center mb-6">
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="border px-4 py-2 rounded"
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="border px-4 py-2 rounded"
        />
        <button
          onClick={handleFilter}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Filter
        </button>
      </div>

      {/* Chart */}
      <div>
        <h2 className="mb-2 text-lg font-semibold text-gray-700">
          👁️ Views per {viewGrouping}
        </h2>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={viewsOverTime}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={viewGrouping}
              angle={-45}
              textAnchor="end"
              interval={0}
              height={100}
            />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="views"
              stroke="#f97316"
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default PostStatistics;
